
import { useMemo } from "react";

export const useForceEngineOptions = () => {
  const forceEngineOptions = useMemo(() => ({
    nodeRelSize: 8,
    d3AlphaDecay: 0.015,
    d3VelocityDecay: 0.2,
    warmupTicks: 50,
    cooldownTicks: 80,
    // Using d3Force as a function that gets called with the d3 force simulation
    // This is the correct way to configure the force layout in react-force-graph
    d3ForceConfig: (d3Force: any) => {
      console.log("Configuring force simulation");
      
      const baseLinkDistance = 80;
      
      // Configure link forces
      d3Force.link()
        .distance(baseLinkDistance)
        .strength(0.2);
      
      // Configure charge forces
      d3Force.charge()
        .strength(-120)
        .distanceMax(200);
      
      // Configure collision forces
      d3Force.collision()
        .radius(30)
        .strength(0.7);
      
      // Configure center forces
      d3Force.center()
        .strength(0.03);
    }
  }), []);

  return forceEngineOptions;
};
